/**
 * @generated SignedSource<<3cff310d4d7975a3695b461400c098bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GoogleCredentials_data$data = {
  readonly googleCredentials: string | null;
  readonly " $fragmentType": "GoogleCredentials_data";
};
export type GoogleCredentials_data$key = {
  readonly " $data"?: GoogleCredentials_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"GoogleCredentials_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GoogleCredentials_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleCredentials",
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "345e91976415aea170433cccde580651";

export default node;
